module.exports = __webpack_public_path__ + "static/section-img4-0d27a82b5fbb583e01e39da50ecbd553.png";